//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useEffect } from "react";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import { toast } from "react-toastify";

// custom pages
import { styles } from "./styles";
import report from "apis/Report/Report";
import { CostCenter } from "./config/config";
import { toastCss, successCss } from "assets/styleJS/global";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// material-ui icons
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { useTranslation } from 'react-i18next';
const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
  },
})(() => null);

export default function Enrollment(props) {
  const { page } = props;
  const { getCostCenter } = report();
  const classes = styles();
  const {t, i18n}= useTranslation()
  const [selectedDate, handleDateChange] = useState(new Date());

  const [states, setstates] = useState({
    columns: [],
    selectedColumns: [],
    selectedFields: [],
    dialog: false,
    data: [],
    response: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // setting checkboxes
  useEffect(() => {
    let label = CostCenter.map((c) => c.label);
    setStates({ columns: label, selectedColumns: label });
  }, []);

  // costcenter api func
  const handleGetCostCenter = async () => {
    try {
      let values = {
        month: selectedDate,
        columns: states.selectedColumns,
      };
      let res = await getCostCenter(values);
      if (res && res.data.length > 0) {
        setStates({ data: res.data, response: true });
        return true;
      } else {
        setStates({ response: true });
      }
    } catch (err) {
      console.log(err);
    }
  };

  // handling customer accounts checkbox
  const checkboxOnChange = (c) => {
    if (!states.selectedColumns?.includes(c)) {
      let selected = [...states.selectedColumns, c];
      let data = [];

      let a = states.columns?.map((c) => {
        selected.map((s) => {
          if (c == s) {
            data = [...data, c];
          }
        });
      });

      setStates({
        selectedColumns: data,
      });
    } else {
      let arr = states.selectedColumns?.filter((e) => e !== c);
      setStates({
        selectedColumns: arr,
      });
    }
  };
  return (
    <div>
      <GlobalCss />
      <div className={classes.selectFieldText}>
        {t('Select month and year to be exported')}
      </div>
      <div className={classes.gridContainer}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            openTo="month"
            views={["year", "month"]}
            value={selectedDate}
            onChange={handleDateChange}
          />
        </MuiPickersUtilsProvider>
      </div>
      <div className={classes.selectFieldText}>
        {t('Select fields to be exported')}
      </div>
      <Grid container spacing={0} className={classes.gridContainer}>
        {states.columns?.map((c, i) => (
          <Grid item xs={6}>
            <FormControlLabel
              key={i}
              control={
                <Checkbox
                  checked={states.selectedColumns?.includes(c)}
                  onChange={() => {
                    checkboxOnChange(c);
                  }}
                  name="checkedB"
                  color="primary"
                />
              }
              label={c}
            />
          </Grid>
        ))}
      </Grid>
      <CSVLink
        id="csv"
        data={[
          [
            `Report :${page?.reportName}`,
            `Generated Date : ${moment(new Date()).format("MM-DD-YYYY")}`,
          ],
          states.selectedColumns,
          ...states.data.map((data) =>
            states.selectedFields?.map((head) =>
              head == "order_date"
                ? moment(data[head]).format("MMM-YY")
                : data[head]
            )
          ),
        ]}
        // headers={states.selectedColumns}
        filename={
          `CostCenterPointDistribution` +
          " " +
          moment(new Date()).format("MM-DD-YYYY,h:mm A") +
          ".csv"
        }
        className={classes.CSVlink}
      />
      <div className={classes.exportAndPreview}>
        <Button
          className={classes.previewBtn}
          onClick={() => {
            if (states?.selectedColumns.length == 0) {
              toast.error("Select any one of the Fields.", {
                ...toastCss,
                autoClose: 5000,
              });
              return;
            } else {
              setStates({ data: [] });
              handleGetCostCenter();
              setStates({ dialog: true });
              let data = [];
              CostCenter.map((c, i) => {
                if (states.selectedColumns?.includes(c.label)) {
                  data = [...data, c.key];
                  return;
                }
              });
              setStates({ selectedFields: data, response: false });
            }
          }}
        >
          {t('Preview')}
        </Button>
        <Button
          className={classes.exportBtn}
          onClick={async () => {
            if (states?.selectedColumns.length == 0) {
              toast.error("Select any one of the Fields.", {
                ...toastCss,
                autoClose: 5000,
              });
              return;
            } else {
              setStates({ data: [] });
              let res = await handleGetCostCenter();
              if (res) {
                let data = [];
                CostCenter.map((c, i) => {
                  if (states.selectedColumns?.includes(c.label)) {
                    data = [...data, c.key];
                    return;
                  }
                });
                setStates({ selectedFields: data });
                document.getElementById("csv").click();
              }
            }
          }}
        >
          {t('Export CSV')}
        </Button>
      </div>

      <Dialog
        onClose={() => {
          setStates({ dialog: false });
        }}
        aria-labelledby="simple-dialog-title"
        open={states.dialog}
      >
        <div className={classes.gridContainer}>
          <Grid container spacing={0}>
            <Grid item xs={12} className={classes.gridOne}>
              {page?.reportName + " " + "Report"}
              <HighlightOffIcon
                className={classes.gridTwo}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              />
            </Grid>
            <Grid item xs={6} className={classes.gridSix}>
              <span className={classes.gridThreeSpan}>
                {t('Report is generated for the month')} :{" "}
              </span>
              <span>{moment(selectedDate).format("MMM-YYYY")}</span>
            </Grid>
            <Grid item xs={6} className={classes.gridFive}>
              <span className={classes.gridThreeSpan}>{t('Generated Date')} : </span>
              <span>{moment(new Date()).format("MM-DD-YYYY")}</span>
            </Grid>
          </Grid>
          {states.response ? (
            states.data && states.data.length > 0 ? (
              <TableContainer className={classes.tableContainer}>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  size={"medium"}
                  aria-label="enhanced table"
                >
                  <TableHead className={classes.tableHead}>
                    <TableRow>
                      {states.selectedColumns?.map((h, i) => (
                        <TableCell key={i} className={classes.tableHeading}>
                          {h}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {states.data?.slice(0, 10)?.map((p, i) => (
                      <TableRow role="checkbox" tabIndex={-1} key={i}>
                        {states.selectedFields.map((s) => (
                          <TableCell align="left" className={classes.rowCell}>
                            {s == "order_date"
                              ? moment(p?.[s]).format("MMM-YY")
                              : p?.[s]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <NoData />
            )
          ) : (
            <Loader Loading={!states?.response}></Loader>
          )}
        </div>
        {states.data && states.data.length > 0 && (
          <Grid container spacing={0}>
            <Grid xs={12} className={classes.gridFour}>
              <Button
                className={classes.previewBtn}
                onClick={() => {
                  setStates({ dialog: false });
                }}
              >
                {t('Cancel')}
              </Button>
              <Button
                className={classes.exportBtn}
                onClick={() => {
                  document.getElementById("csv").click();
                }}
              >
                {t('Export CSV')}
              </Button>
            </Grid>
          </Grid>
        )}
      </Dialog>
    </div>
  );
}
